module.exports = __webpack_public_path__ + "img/landscape-morning-fog-mountains-with-hot-air-balloons-sunrise.ba46582d.png";